<template>
  <div>
    <el-row style="margin-top:10px;">
      <el-col :span="6">
        <div class="top-index">
          <div class="number"><router-link to="/car">{{ carList.length }}</router-link></div>
          <div class="label">车辆总数</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="top-index">
          <div class="number online"><router-link to="/car">{{ onlineCount }}</router-link></div>
          <div class="label">在线车辆</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="top-index">
          <div class="number offline"><router-link to="/car">{{ offlineCount }}</router-link></div>
          <div class="label">离线车辆</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="top-index">
          <div class="number nodevice"><router-link to="/car">{{ noDeviceCount }}</router-link></div>
          <div class="label">未安装GSP设备</div>
        </div>
      </el-col>
    </el-row>
    <div id="car-map-tdt" ref="mapEl"></div>
  </div>
</template>

<script>
import moment from 'moment'
import offset from '../../assets/offset'
import { loadTianditu } from '@/utils/tianditu'
export default {
  data () {
    return {
      center: [114.279737, 30.563086],
      zoom: 15,
      carList: [],
      markers: [],
      map: null
    }
  },
  computed: {
    onlineCount () {
      return this.carList.filter(r => r.device_id && !this.isOffline(r)).length
    },
    offlineCount () {
      return this.carList.filter(r => r.device_id && this.isOffline(r)).length
    },
    noDeviceCount () {
      return this.carList.filter(r => !r.device_id).length
    }
  },
  mounted () {
    this.initMap()
    this.fetchCarList()
  },
  watch: {
    center: {
      handler () {
        this.updateCenter()
      },
      deep: true
    },
    markers: {
      handler () {
        this.renderMarkers()
      },
      deep: true
    }
  },
  methods: {
    async initMap () {
      try {
        await loadTianditu()
        if (!this.$refs.mapEl) return
        if (this.map) return
        const T = window.T
        this.map = new T.Map(this.$refs.mapEl)
        this.map.centerAndZoom(new T.LngLat(this.center[0], this.center[1]), this.zoom)
        this.map.enableScrollWheelZoom()
        if (T.Control && T.Control.Zoom) {
          this.map.addControl(new T.Control.Zoom())
        }
        if (T.Control && T.Control.Scale) {
          this.map.addControl(new T.Control.Scale())
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }
    },
    updateCenter () {
      if (!this.map || !window.T) return
      const T = window.T
      this.map.centerAndZoom(new T.LngLat(this.center[0], this.center[1]), this.zoom)
    },
    renderMarkers () {
      if (!this.map || !window.T) return
      const T = window.T
      this.map.clearOverLays()
      if (!this.markers || this.markers.length === 0) return

      const points = []
      for (let i = 0; i < this.markers.length; i++) {
        const m = this.markers[i]
        const lnglat = new T.LngLat(m.position[0], m.position[1])
        points.push(lnglat)

        const marker = new T.Marker(lnglat)
        this.map.addOverLay(marker)

        const label = new T.Label({
          text: m.text,
          position: lnglat,
          offset: new T.Point(0, 18)
        })
        this.map.addOverLay(label)
      }

      // 自动调整视野，确保全部点都能看到
      if (points.length > 1) {
        this.map.setViewport(points)
      } else if (points.length === 1) {
        this.map.centerAndZoom(points[0], this.zoom)
      }
    },
    fetchCarList () {
      this.$http.get('/dbapi/car_list').then(response => {
        if (response.data.success) {
          this.carList = response.data.list
          let list = []
          for (var i = 0; i < this.carList.length; i++) {
            if (this.carList[i].device_id && !this.isOffline(this.carList[i])) {
              list.push({ 
                id: this.carList[i].id,
                text: this.carList[i].car_alias,
                position: offset(parseFloat(this.carList[i].lon), parseFloat(this.carList[i].lat))
              })
            }
          }
          this.markers = list
          if (list.length > 0) {
            this.center = list[0].position
          }
        }
      })
    },
    isOffline (row) {
      if (!row.gps_upload_time) return true
      return moment().diff(moment(row.gps_upload_time), 'minutes') > 10
    }
  },
  beforeDestroy () {
    if (this.map && this.map.clearOverLays) {
      this.map.clearOverLays()
    }
    this.map = null
  }
}
</script>

<style>
.top-index {
  padding-bottom: 10px;
  border-bottom: 1px solid #cfd7e5;
}
.top-index .number {
  text-align: center;
  color: #15a0ff;
  font-size: 30px;
}
.top-index .number a {
  color: #15a0ff;
  text-decoration: none;
}
.top-index .number a:hover {
  color: #f65573;
  text-decoration: none;
}
.top-index .online a {
  color: green;
}
.top-index .offline a {
  color: red;
}
.top-index .nodevice a {
  color: #000;
}
.top-index .label {
  text-align: center;
  color: #999;
  font-size: 14px;
}
#car-map-tdt {
  height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/rent/CarMap.vue